export const CREATORS = ['ku', 'nano_10moya3', 'jonpi1219'] as const
export type CREATOR = (typeof CREATORS)[number]

export const creatorMapTargetId: Record<CREATOR, string> = {
  ku: 'monsterHunterRiseSunBreak1',
  nano_10moya3: 'monsterHunterRiseSunBreak2',
  jonpi1219: 'monsterHunterRiseSunBreak3',
}

export const mapMonsterHunterRiseSunbreakCreatorInfo: Record<
  CREATOR,
  {
    profileCardImageURL: string
    creatorImageURL: string
  }
> = {
  ku: {
    profileCardImageURL: `/static/images/profiles/monsterHunterRiseSunBreak1/0.jpeg`,
    creatorImageURL: '/static/images/creators/ku.png',
  },
  nano_10moya3: {
    profileCardImageURL: `/static/images/profiles/monsterHunterRiseSunBreak2/0.jpeg`,
    creatorImageURL: '/static/images/creators/nano_10moya3.png',
  },
  jonpi1219: {
    profileCardImageURL: `/static/images/profiles/monsterHunterRiseSunBreak3/0.jpeg`,
    creatorImageURL: '/static/images/creators/jonpi1219.png',
  },
}
